// pages/ContactPage/ContactPage.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaEnvelope, FaClock, FaMapMarkerAlt, FaBan } from 'react-icons/fa';
import './css/ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page" dir="rtl">
      
      {/* Header */}
      <header className="contact-header">
        <div className="container relative-z">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            تواصلي معي
          </motion.h1>
          <p>أنا هنا لمساعدتك في رحلتك الأكاديمية.</p>
        </div>
      </header>

      <section className="contact-content">
        <div className="container">
          <div className="row g-5">
            
            {/* 1. Contact Info Column */}
            <div className="col-lg-5">
              <motion.div 
                className="contact-info-box"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
              >
                <h3>معلومات التواصل</h3>
                <p className="intro-text">
                  للاستفسارات السريعة وحجز المواعيد، الوسيلة الأسرع هي الواتساب.
                </p>

                <div className="info-item whatsapp-highlight">
                  <div className="icon-box"><FaWhatsapp /></div>
                  <div>
                    <h4>الواتساب (للرسائل فقط)</h4>
                    <a href="https://wa.me/966530494038" target="_blank" rel="noreferrer" className="wa-link">
                      0530494038 (+966)
                    </a>
                    <span className="status-badge">متاح الآن</span>
                  </div>
                </div>

                <div className="info-item">
                  <div className="icon-box"><FaEnvelope /></div>
                  <div>
                    <h4>البريد الإلكتروني</h4>
                    <p>support@drnuha.com</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="icon-box"><FaClock /></div>
                  <div>
                    <h4>أوقات العمل</h4>
                    <p>الفترة الصباحية: من 8:00 ص إلى 12:00 م</p>
                    <p>الفترة المسائية: من 2:00 م إلى 6:00 م</p>
                    <p className="sub-text">(يوميًا عدا الجمعة — الحجز عبر صفحة الحجز)</p>
                  </div>
                </div>

                <div className="info-item warning-item">
                  <div className="icon-box"><FaBan /></div>
                  <div>
                    <h4>تنبيه هام</h4>
                    <p>لا نستقبل المكالمات الهاتفية، التواصل كتابي فقط.</p>
                  </div>
                </div>

              </motion.div>
            </div>

            {/* 2. Contact Form Column */}
            <div className="col-lg-7">
              <motion.div 
                className="contact-form-wrapper"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <h3>راسليني عبر الموقع</h3>
                <form className="main-form">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label>الاسم الكريم</label>
                      <input type="text" className="form-control" placeholder="اسمك" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>البريد الإلكتروني</label>
                      <input type="email" className="form-control" placeholder="example@mail.com" />
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label>نوع الاستفسار</label>
                    <select className="form-control">
                      <option>استفسار عام</option>
                      <option>مشكلة في الحجز</option>
                      <option>طلب تعاون</option>
                      <option>أخرى</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label>الرسالة</label>
                    <textarea className="form-control" rows="5" placeholder="اكتبي رسالتك هنا..."></textarea>
                  </div>

                  <button type="button" className="btn-send">إرسال الرسالة</button>
                </form>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default ContactPage;